// Module
var code = "<template>\n  <div class=\"empty-list\" class.bind=\"isEmpty ? '' : 'empty-list--hidden'\">\n    <div class=\"empty-list__text\">${message}</div>\n  </div>\n</template>\n";
// Exports
export default code;